import React from 'react';
import ReactDOM from 'react-dom';
import Login from './components/Login';

export default function showLogin() {
  ReactDOM.unmountComponentAtNode(document.getElementById('root'));
  ReactDOM.render(<Login />, document.getElementById('root'));
}



// WEBPACK FOOTER //
// ./src/showLogin.js